




































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';
// import { Dictionary } from 'vuex';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';
import LangSelect from '@/components/global/LangSelect/index.vue';
import GlobalProgress from '@/components/global/Progress/index.vue';
import ThemeSelect from '@/components/global/ThemeSelect/index.vue';
import { translateViewResource } from '@/utils/index';
import {
  validateUserTokenExisted,
  validateUserTokenNotExpired,
} from '@/router/permission';
import { PermissionModule } from '@/store/modules/permission';
import { configureRoutesAfterLoggedIn } from '@/utils/permission';
import {
  getAfterLoginRedirectUrl,
  removeAfterLoginRedirectUrl,
} from '../../utils/localstorage';

@Component({
  name: 'Login',
  components: {
    LangSelect,
    GlobalProgress,
    ThemeSelect,
  },
})
export default class extends Vue {
  private loginFormValid = false;
  private supplierId = '';
  private supplierIdRules: ((v: string) => boolean | string)[] = [];
  private username = '';
  private usernameRules: ((v: string) => boolean | string)[] = [];
  private password = '';
  private passwordRules: ((v: string) => boolean | string)[] = [];
  private errorMessages = 'Incorrect login info';
  private snackbar = false;
  private showPassword = false;
  private loginBtnLoading = false;
  private redirect?: string;
  private otherQuery: any = {};

  get appLanguage() {
    return AppModule.language;
  }

  get tokenNotExisted() {
    return PermissionModule.userTokenPermission.tokenNotExisted;
  }

  get tokenExpired() {
    return PermissionModule.userTokenPermission.tokenExpired;
  }

  get unauthenticated() {
    return PermissionModule.userTokenPermission.unauthenticated;
  }

  get supplierIdItems() {
    return UserModule.supplierIds;
  }

  @Watch('$route', { immediate: true })
  private onRouteChange(route: Route) {
    // TODO: remove the "as Dictionary<string>" hack after v4 release for vue-router
    // See https://github.com/vuejs/vue-router/pull/2050 for details
    const query = route.query as any;
    if (query) {
      this.redirect = query.redirect;
      this.otherQuery = this.getOtherQuery(query);
    }
  }

  @Watch('appLanguage')
  private onLangSelected() {
    (this.$refs.loginFormRef as any).resetValidation();
    this.autoFocus();
  }

  @Watch('tokenNotExisted', { immediate: true })
  private onTokenNotExistedChanged(value: boolean) {
    if (value) {
      this.$toast.error(
        this.translateViewResource('User not logged in') as string,
        {
          icon: 'mdi-account-question',
        }
      );
      this.$nextTick(() => {
        PermissionModule.ResetUserTokenPermission();
      });
    }
  }

  @Watch('unauthenticated', { immediate: true })
  private onTokenUnauthenticatedChanged(value: boolean) {
    if (value) {
      this.$toast.error(
        this.translateViewResource('User unauthenticated') as string,
        {
          icon: 'mdi-account-lock',
        }
      );
      this.$nextTick(() => {
        PermissionModule.ResetUserTokenPermission();
      });
    }
  }

  @Watch('tokenExpired', { immediate: true })
  private onTokenExpiredChanged(value: boolean) {
    if (value) {
      this.$toast.error(
        this.translateViewResource(
          'Your Session has expired, please relogin'
        ) as string,
        {
          icon: 'mdi-account-clock',
        }
      );
      this.$nextTick(() => {
        PermissionModule.ResetUserTokenPermission();
      });
    }
  }

  created() {
    this.supplierIdRules = [
      (v: string) =>
        !!v ||
        (this.translateViewResource('{msg} is required', {
          msg: this.$t('Supplier Id'),
        }) as string),
    ];
    this.usernameRules = [
      (v: string) =>
        !!v ||
        (this.translateViewResource('{msg} is required', {
          msg: this.$t('Username'),
        }) as string),
    ];
    this.passwordRules = [
      (v: string) =>
        !!v ||
        (this.translateViewResource('{msg} is required', {
          msg: this.$t('Password'),
        }) as string),
    ];
  }

  mounted() {
    this.autoFocus();
  }

  private autoFocus() {
    if (this.supplierId === '') {
      (this.$refs.supplierId as HTMLInputElement).focus();
    } else if (this.username === '') {
      (this.$refs.username as HTMLInputElement).focus();
    } else if (this.password === '') {
      (this.$refs.password as HTMLInputElement).focus();
    }
  }

  private removeSupplierId(supplierId: string) {
    UserModule.removeSupplierId(supplierId);
  }

  private isRedirected() {
    return this.$route.fullPath !== '/login';
  }

  private async handleLogin() {
    if (!this.loginFormValid) {
      return;
    }
    AppModule.StartProgress();
    try {
      await UserModule.Login({
        supplierId: this.supplierId,
        username: this.username,
        password: this.password,
      });
      this.postLogin();
    } catch (err) {
      AppModule.StopProgress();
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t('Login') as string).toLowerCase(),
          err: this.$t('Invalid Supplier Id, username or password'),
        }) as string,
        {
          icon: 'mdi-account-alert',
        }
      );
    }
  }

  private postLogin() {
    UserModule.addSupplierId(this.supplierId);
    configureRoutesAfterLoggedIn(this.$router);
    AppModule.StopProgress();

    const afterLoginUrl = getAfterLoginRedirectUrl();
    if (afterLoginUrl) {
      this.$router
        .push({
          path: afterLoginUrl,
          query: this.otherQuery,
        })
        .then(_ => {
          this.$nextTick(() => removeAfterLoginRedirectUrl());
        });
    } else {
      this.$router.push({
        path: this.redirect || '/',
        query: this.otherQuery,
      });
    }
  }

  private getOtherQuery(query: any) {
    return Object.keys(query).reduce((acc, cur) => {
      if (cur !== 'redirect') {
        acc[cur] = query[cur];
      }
      return acc;
    }, {} as any);
  }

  private translateViewResource(
    resource: string,
    options?: { [key: string]: any }
  ) {
    return translateViewResource(
      this.$i18n,
      this.$options.name as string,
      resource,
      options
    );
  }
}
